import React, { Component } from "react"
import { Button, Col, Container, Form, Modal, Row } from "react-bootstrap"
import DatePicker from 'react-datepicker'
import { Subscription } from "rxjs"
import 'react-datepicker/dist/react-datepicker.css'
import { BirthdayInput } from "../FormattedInputs/BirthdayInput"
import { toast } from "react-toastify"
import { APIError } from "../../api/ObservableFromFetch"
import CompanyPoolsGet, { CompanyPool } from "../../api/OrderResults/CompanyPoolsGet"
import ActionButton from "../ActionButton"
import CompleteTest, { UnarchiveTest } from "../../api/OrderResults/CompleteTest"

export interface TestToProcess {
  TestEventID?: number
  TestDetailID: string
  TestDetailClinicalID: string
  PersonID: number
  HireDate: Date | undefined
  PoolID: number | string | null
  Images: string[]
  DonorName?: string
  AuthorizationID?: string
}

interface CompleteModalProps {
  selectedTests: TestToProcess[]
  unarchive: boolean
  show: boolean
  onHide: () => void
  onSave: () => void
}

interface CompleteModalState {
  currentTest: TestToProcess
  hireDate: Date | undefined
  pools: CompanyPool[]
  saving: boolean
  didHire: boolean | undefined
  showHireModal: boolean
  showCompleteModal: boolean
  testsToProcess: TestToProcess[]
  processedTests: TestToProcess[]
  currentDonorIndex: number
}


export default class CompleteModal extends Component<CompleteModalProps, CompleteModalState> {
  state: CompleteModalState = {
    pools: [],
    hireDate: undefined,
    saving: false,
    didHire: undefined,
    currentTest: this.props.selectedTests[0],
    currentDonorIndex: 0,
    showHireModal: this.props.selectedTests.length !== 1,
    showCompleteModal: this.props.selectedTests.length === 1,
    testsToProcess: this.props.selectedTests,
    processedTests: []
  }

  hiredate = React.createRef<DatePicker>()
  poolSubscription?: Subscription
  saveSubscription?: Subscription

  componentDidMount() {
    this.poolSubscription = CompanyPoolsGet(this.state.testsToProcess[0]?.TestEventID || 0).subscribe(
      (data) => this.setState({ pools: data }),
      (error) => this.handleAPIError(error, {})
    )
    this.completeAllTests(0)
  }

  componentWillUnmount() {
    this.poolSubscription && this.poolSubscription.unsubscribe()
    this.saveSubscription && this.saveSubscription.unsubscribe()
  }

  handlePoolChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value
    this.setState({ currentTest: { ...this.state.currentTest, PoolID: value } })
  }

  handleAPIError = (error: Error | APIError, stateChanges: object) => {
    this.setState(stateChanges)
    error && toast.error((error as APIError)?.errorData?.message || error.message)
  }

  onCancelHireModal = () => {
    this.setState({ showHireModal: false })
    this.props.onHide()
  }

  onSubmitHireModal = () => {
    if (this.state.didHire) {
      this.setState({ showCompleteModal: true })
    }
    else {
      this.setState({ saving: true })
      this.completeAllTests(0)
    }
  }

  completeTest = () => {
    this.setState({ saving: true })
    const { currentTest } = this.state

    const testToComplete: TestToProcess = {
      TestDetailID: currentTest.TestDetailID,
      TestDetailClinicalID: currentTest.TestDetailClinicalID,
      PersonID: currentTest.PersonID,
      HireDate: this.state.hireDate,
      PoolID: currentTest.PoolID || null,
      Images: currentTest.Images || []
    }

    this.saveSubscription = CompleteTest(testToComplete).subscribe(
      (data) => {
        toast.success("Test was successfully marked archived.")
        this.setState({ saving: false, processedTests: [ ...this.state.processedTests, testToComplete ] })
      },
      (error) => this.handleAPIError(error, { saving: false })
    )
  }

  completeAllTests = (currentIndex: number) => {
    const currentTest = this.state.testsToProcess[currentIndex]
    const testToComplete: TestToProcess = {
      TestDetailID: currentTest.TestDetailID,
      TestDetailClinicalID: currentTest.TestDetailClinicalID,
      PersonID: currentTest.PersonID,
      HireDate: undefined,
      PoolID: 0,
      Images: []
    }

    if (!!this.props.unarchive) {
      this.saveSubscription = UnarchiveTest(testToComplete).subscribe(
      (data) => {
        if (currentIndex + 1 === this.state.testsToProcess.length) {
          toast.success("Tests were successfully unarchived.")
          this.setState({ showHireModal: false, saving: false })
          this.props.onHide()
          this.props.onSave()
        }
        else this.completeAllTests(currentIndex + 1)
      },
      (error) => this.handleAPIError(error, { saving: false })
    )
    }
    else {
      this.saveSubscription = CompleteTest(testToComplete).subscribe(
        (data) => {
          if (currentIndex + 1 === this.state.testsToProcess.length) {
            toast.success("Tests were successfully marked archived.")
            this.setState({ showHireModal: false, saving: false })
            this.props.onHide()
            this.props.onSave()
          }
          else this.completeAllTests(currentIndex + 1)
        },
        (error) => this.handleAPIError(error, { saving: false })
      )
    }
  }

  onSubmit = () => {
    this.completeTest()
  }

  onCancel = () => {
    const { testsToProcess, currentDonorIndex } = this.state
    if (testsToProcess.length === 1 || currentDonorIndex + 1 === testsToProcess.length) {
      this.props.onHide()
      this.props.onSave()
    }
    else {
      const newDonorIndex = currentDonorIndex + 1
      const newDonorTest = this.state.testsToProcess[newDonorIndex]
      const testForSameDonor =  this.state.processedTests.find(item => item.PersonID === newDonorTest.PersonID && item.HireDate)
      const hireDate = testForSameDonor?.HireDate ? testForSameDonor.HireDate : undefined
      this.setState({ currentTest: { ...newDonorTest}, currentDonorIndex: newDonorIndex, hireDate: hireDate })
    }
  }

  render() {
    const { testsToProcess, currentTest, pools, currentDonorIndex, showHireModal, showCompleteModal, processedTests, hireDate } = this.state
    const lastDonor = currentDonorIndex + 1 === testsToProcess.length
    const testForSameDonor = processedTests.some(item => item.PersonID === currentTest.PersonID && item.TestDetailID !== currentTest.TestDetailID && item.HireDate)
    return (
      <>
      </>
    )
  }
}
